/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_Step2_DescInputs */

const en_existing_step2_desc = /** @type {(inputs: Existing_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your coding agent from the directory you want analysed, then paste the prompt.`)
};

const id_existing_step2_desc = /** @type {(inputs: Existing_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka coding agent pilihanmu dari direktori yang mau dianalisis, lalu tempel prompt tadi.`)
};

/**
* | output |
* | --- |
* | "Open your coding agent from the directory you want analysed, then paste the prompt." |
*
* @param {Existing_Step2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_step2_desc = /** @type {((inputs?: Existing_Step2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Step2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_step2_desc(inputs)
	return en_existing_step2_desc(inputs)
});